import {
  ROUTE_ADMIN,
  ROUTE_ADMIN_TREATMENT,
} from '../../../Routes/routes';

const breadcrumbs = (t) => [{
  title: t('Views.adminTitle'),
  route: `/${ROUTE_ADMIN}`,
}, {
  title: t('Admin.treatmentTitle'),
  route: `/${ROUTE_ADMIN_TREATMENT}`,
}];

export default breadcrumbs;
